import { Component, OnInit } from '@angular/core';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Observable } from 'rxjs';
import { Stream } from 'src/models/stream';
import { Country } from 'src/models/country';
import { ActivatedRoute } from '@angular/router';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-music',
  templateUrl: './music.component.html',
  styleUrls: ['./music.component.scss']
})
export class MusicComponent implements OnInit, ListStreamsI {

  public countries = new Array<Country>();

  public countryId: string;

  constructor(private activatedRoute: ActivatedRoute, private streamService: StreamService) {}

  ngOnInit() {
    this.streamService.getCountriesWithMusicStations().subscribe((value: Country[]) => {
      this.countries = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.countryId = params['id'];
    });
  }

  public getHeadline(): string {
    const country = this.countries.find((country: Country) => country.id === this.countryId);

    return country !== undefined ? country.name : 'Alle';
  }

  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const observable = this.countryId !== undefined
                            ? this.streamService.getMusicStationsByCountry(this.countryId, start, itemsPerPage)
                            : this.streamService.getStationsByCategory(31, start, itemsPerPage);

    return observable;
  }

}
